













import Vue, { PropType } from 'vue';
import { SiteErrorData } from '@/types';
import { PageNotFound } from '@/constants';

export default Vue.extend({
  name: 'SiteErrorPage',
  props: {
    error: {
      type: Object as PropType<SiteErrorData>,
      default () {
        return PageNotFound();
      }
    },
    signedIn: {
      type: Boolean,
      default: false
    }
  }
});
